module.exports = __webpack_public_path__ + "img/icon-delete-2.4359bc33.svg";